import { render } from "./AnimatedHero.vue?vue&type=template&id=56a87171&scoped=true"
import script from "./AnimatedHero.vue?vue&type=script&lang=js"
export * from "./AnimatedHero.vue?vue&type=script&lang=js"

import "./AnimatedHero.vue?vue&type=style&index=0&id=56a87171&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a87171"]])

export default __exports__